import { render } from "./YesButton.vue?vue&type=template&id=a53e446e&scoped=true"
import script from "./YesButton.vue?vue&type=script&lang=ts"
export * from "./YesButton.vue?vue&type=script&lang=ts"

import "./YesButton.vue?vue&type=style&index=0&id=a53e446e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a53e446e"

export default script